import { Box } from '@mui/material';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import { timeFormatter } from '@act/shared/utilities';

interface InsurancePlanEntryProps {
  clientUserId: string;
  dsnpFlag: boolean;
  effectiveDate: number;
  insurancePlanName: string;
}

const InsurancePlanEntry = ({
  clientUserId,
  dsnpFlag,
  effectiveDate,
  insurancePlanName,
}: InsurancePlanEntryProps) => {
  return (
    <LabeledDatum
      label="Plan"
      datum={
        <Box>
          <Box>
            {insurancePlanName}
            {dsnpFlag ? ' (DSNP)' : ''}
          </Box>
          <Box>{clientUserId}</Box>
          <Box>
            Effective date:{' '}
            {timeFormatter.epochToHumanReadableDate({
              date: effectiveDate,
              includeTime: false,
            })}
          </Box>
        </Box>
      }
    />
  );
};

export default InsurancePlanEntry;
